<template>
  <div>
    <b-row class="mb-5 justify-content-end">
      <!-- Left section filtre -->
      <div class="d-flex justify-content-end mt-2 col-lg-2 col-xl-2 col-4">
        <b-button class="btnFilter_2 mx-3"
                  @click="trigOnImportCSV" variant="primary">
          <i class="fa-light fa-plus "></i>
          <span class="fab-label">{{ $t('toolbox.import_testcase') }}</span>
        </b-button>
        <input type="file" ref="fileInput" class="d-none" @change="onImportCSV" accept=".csv"/>
      </div>
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <hr  class="mx-auto"/>
    <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center" >
      <!--Filtre Status -->
      <b-col sm="6" lg="2" class="filter-item">
        <div>
          <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.select_t_c_result') }}</span>
          <select v-model="StatusFilter" class="filter-item-content w-100" style="padding:0.5rem;">
            <option value="" selected>----------</option>
            <option value="2">{{ $t('toolbox.filtre_status_ok') }}</option>
            <option value="0">{{ $t('toolbox.filtre_status_ko') }}</option>
            <option value="3">{{ $t('toolbox.filtre_status_missing_conf') }}</option>
            <option value="4">{{ $t('account_tb.status.RUN') }}</option>
            <option value="5">{{ $t('account_tb.status.NULL') }}</option>
          </select>
        </div>
      </b-col>
      <!--Filtre Case Summary -->
      <b-col sm="6" lg="2"  class="filter-item">
        <input-filter-dropdown-list
            @update-val="updateVal"
            :reset-trigger="resetSignal"
            :label="$t('toolbox.filtre_case_summary')"
            :item-list="AllRowName"
            trad-path="toolbox.req_summary_case"
        ></input-filter-dropdown-list>
      </b-col>
      <b-col cols="2">
        <div>
          <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.date_begin') }}</span>
          <datetime-picker-custom format="YYYY-MM-DD HH:mm:ss" periodFull
            id="filter-datebegin"
            class="mr-3"
            :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilter}"
            customInputParentClass="filter-item-content"
            customInputClass="w-100"
            :maxLength="19"
            :placeholderValue="$t('common.datetime_picker_empty_date')"
            inputIcon="fa-solid fa-calendar"
            v-model="dateBeginFilter">
          </datetime-picker-custom>
        </div>
      </b-col>
      <b-col cols="2">
        <div>
          <span class="filter-item-title d-block mb-1">{{ $t('injection_tab.date_end') }}</span>
          <datetime-picker-custom format="YYYY-MM-DD HH:mm:ss" periodFull
            id="filter-datebegin"
            class="mr-3"
            :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilter}"
            customInputParentClass="filter-item-content"
            customInputClass="w-100"
            :maxLength="19"
            :placeholderValue="$t('common.datetime_picker_empty_date')"
            inputIcon="fa-solid fa-calendar"
            v-model="dateEndFilter">
          </datetime-picker-custom>
        </div>
      </b-col>
      <b-col>
      </b-col>
      <b-col cols="2">
        <b-col class="d-flex justify-content-end align-items-center mt-4 px-0">
          <b-button class="btnResetFilter mr-2 px-3 py-1 w-auto col-6" @click="clearFilterFields"
            :disabled="!hasInputFilter">
            {{ $t('injection_tab.reset') }}
          </b-button>
          <b-button class="btnDoFilter px-3 py-1 w-auto col-6" variant="primary"
            @click="applyFilter()">
            {{ $t('common.srch') }}
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-end mb-5 mr-1" v-if="displayFilter">
      <!-- Bouton Effacer et Appliquer -->

    </b-row>
    <hr  class="mx-auto mb-4" v-if="displayFilter"/>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="RequestList.length" style="overflow:auto">
      <b-table hover
        class="table table-striped"
        style="margin-bottom:0"
        :fields="fields"
        :items="RequestList"
        :selectable="RequestList.length > 0"
        :per-page="paginationObject.maxResults"
        :current-page="pageCounter"
        :empty-text="$t('common.security.no_result')"
        @row-clicked="seeRequestTBDetails">

        <template #cell(response_request)="data">
          <div> {{data.item.ids_dataset.length}} </div>
        </template>

        <template #cell(case_summary)="data">
          <div class="py-3 w-auto"> {{ $t(`toolbox.req_summary_case.${data.item.case_summary}`) }} </div>
        </template>

        <template #cell(description_case)="data">
          <div> {{ $t(`toolbox.req_description_case.${data.item.description_case}`) }} </div>
        </template>

        <template #cell(case_type)="data">
          <div class="py-3 w-auto"> {{ $t(`toolbox.req_case_type.${data.item.case_type}`) }} </div>
        </template>

        <template #cell(lastExec)="data">
          <div class="py-3 w-auto"> {{ data.value | formatDateTime }} </div>
        </template>

        <template #cell(case_type_detailed)="data">
          <div class="py-3 w-auto" v-if="data.item.case_type_detailed.length > 0"> {{ $t(`toolbox.req_case_type_detailed.${data.item.case_type_detailed}`) }} </div>
          <div class="py-3 w-auto" v-else> </div>
        </template>

        <template #cell(status)="data">
          <div v-if="data.value === '2'">
            <i title="OK" class="fas fa-check bg-success text-white"
               style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
          <div v-else-if="data.value === '0'">
            <i title="KO" class="fas fa-multiply bg-danger text-white"
               style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
          <div v-else-if="data.value === '1'">
            <i title="RUN" class="fas fa-hourglass-half text-white"
               style="background-color: orange; border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
          <div v-else-if="data.value === '3'">
            <i  title="Missing configuration" class="fas fa-file-alt" style="color: gray; font-size: 20px;"></i>
          </div>
          <div v-else-if="data.value === '4'">
            <i title="RUNNING" class="fas fa-hourglass-half" style="color: gray; font-size: 20px;"></i>
          </div>
          <div v-else-if="data.value === '5'">
            <i title="Not tested" class="fas fa-minus bg-secondary text-white"
               style="border-radius: 50%;display: inline-flex; justify-content: center; align-items: center;">
            </i>
          </div>
        </template>

      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5" v-if="!activateSpinner && RequestList.length">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import moment from 'moment'

import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import inputFilterDropDownList from "@/pages/toolbox/InputFilterDropDownList.vue";
import dateTimePicker from '@/components/common/dateTimePicker.vue'

export default {
  name: 'RequestTBList',
  components: {
    'cm-pagination': Pagination,
    'datetime-picker-custom': dateTimePicker,
    'spinner': Spinner,
    'input-filter-dropdown-list': inputFilterDropDownList
  },
  computed: {
    fields () {
      let fields
      fields = [
        { key: 'id', label: this.$i18n.t('toolbox.list_id'), class: 'text-center', sortable: false },
        { key: 'case_summary', label: this.$i18n.t('toolbox.list_case_summary'), class: 'text-center', sortable: false },
        { key: 'case_type', label: this.$i18n.t('toolbox.list_case_type'), class: 'text-center', sortable: false },
        { key: 'case_type_detailed', label: this.$i18n.t('toolbox.list_case_type_detailed'), class: 'text-center', sortable: false },
        { key: 'response_request', label: this.$i18n.t('toolbox.list_response_request'), class: 'text-center', sortable: false },
        { key: 'lastExec', label: this.$i18n.t('toolbox.list_last_exec'), class: 'text-center', sortable: false },
        { key: 'status', label: this.$i18n.t('toolbox.list_status'), class: 'text-center', sortable: false },
      ]
      return fields
    },
    hasInputFilter () {
      return this.CaseSummary.length > 0 || this.StatusFilter !== '' || this.referenceTestInput.length || this.dateBeginFilter || this.dateEndFilter;
    },
  },
  data () {
    return {
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      dateBeginFilter: '',
      dateEndFilter: '',
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      statusVerification: '',
      VopProvider: '',
      Result: '',
      CaseSummary: '',
      ResultFilter: '',
      StatusFilter: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      RequestList: [],
      AllRowName: [],
      resetSignal: 0,
      isDropdownOpen: false,
      referenceTestInput: ''
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.tracking.cleanFilterCondition()
  },
  methods: {
    updateVal(newVal) {
      this.CaseSummary = newVal
    },
    applyFilter (filterConditions = {}) {
      let that = this
      this.RequestList = []
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 10
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.tracking.cleanFilterCondition()

      filterConditions.CaseSummary = this.CaseSummary.trim()
      filterConditions.StatusFilter = this.StatusFilter
      filterConditions.DateBegin = this.dateBeginFilter ? moment(this.dateBeginFilter).utc().format('YYYY-MM-DD HH:mm:ss') : undefined
      filterConditions.DateEnd = this.dateEndFilter ? moment(this.dateEndFilter).utc().format('YYYY-MM-DD HH:mm:ss') : undefined
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex

      this.$engine.toolbox.getTestCaseTB(
          //this.$engine.toolbox.getAccountTB(
          filterConditions
      ).then(resp => {
        this.RequestList = []
        if (resp.data.TestCase) {
          let requests = []
          if(resp.data.TestCase.List){
            let result = []
            if(!Array.isArray(resp.data.TestCase.List))
              result.push(resp.data.TestCase.List)
            else {
              result = resp.data.TestCase.List
            }
            if (result.length > 0){
              result.forEach( test =>{
                let aux = {}
                aux.id = test["~Unknown_1"]
                if(aux.id !== "$NotFound") {
                  aux.case_summary = test["~Unknown_2"]
                  aux.description_case = test["~Unknown_3"]
                  aux.case_type = test["~Unknown_4"]
                  aux.case_type_detailed = test["~Unknown_5"]
                  aux.tested_field = test["~Unknown_6"]
                  aux.criticality = test["~Unknown_7"]
                  aux.status = test["~Unknown_8"]
                  let execution = test["~Unknown_9"]
                  execution = execution.replace("T", " ")
                  execution = this.date_format(execution)
                  aux.lastExec = execution
                  const foundElement = requests.find(item => item.id === aux.id);
                  if (foundElement) {
                    if (aux.id_dataset.length > 0)
                      foundElement.ids_dataset.push(aux.id_dataset)
                  } else {
                    let newTestCase = {
                      id: aux.id,
                      case_summary: aux.case_summary,
                      description_case: aux.description_case,
                      case_type: aux.case_type,
                      case_type_detailed: aux.case_type_detailed,
                      tested_field: aux.tested_field,
                      criticality: aux.criticality,
                      status: aux.status,
                      lastExec : aux.lastExec,
                      ids_dataset: [],
                      ids_valid: []
                    }
                    requests.push(newTestCase)
                  }
                }
              })
            }
          }
          if(resp.data.TestCase.DatasetCount){
            let result = []
            if(!Array.isArray(resp.data.TestCase.DatasetCount))
              result.push(resp.data.TestCase.DatasetCount)
            else {
              result = resp.data.TestCase.DatasetCount
            }
            if (result.length > 0) {
              result.forEach(test => {
                let cur = {}
                cur.idTestCase = test["~Unknown_1"]
                cur.idDataset = test["~Unknown_2"]
                const foundElement = requests.find(item => item.id === cur.idTestCase);
                if (foundElement) {
                  if (cur.idDataset.length > 0)
                    foundElement.ids_dataset.push(cur.idDataset)
                }
              })
            }
          }
          if(resp.data.TestCaseValid){
            let testCaseValid = []
            if(Array.isArray(resp.data.TestCaseValid))
              testCaseValid = resp.data.TestCaseValid
            else
              testCaseValid.push(resp.data.TestCaseValid)
            testCaseValid.forEach(valid_dataset => {
              let aux = {}
              aux.idTC = valid_dataset["~Unknown_1"]
              aux.idDS = valid_dataset["~Unknown_2"]
              aux.idStatus = valid_dataset["~Unknown_3"]
              aux.lastExec = valid_dataset["~Unknown_4"]
              const foundElement = requests.find(item => item.id === aux.idTC);
              if(foundElement) {
                foundElement.ids_valid.push(aux.idDS)
              }
            })
          }
          that.paginationObject.nbResultsTotal = resp.data.TestCaseCount
          that.paginationObject.nbResults = requests.length
          that.updateInbox(requests)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.CaseSummary = ''
      this.StatusFilter = ''
      this.referenceTestInput = ''
      this.dateBeginFilter = ''
      this.dateEndFilter = ''
      this.resetSignal++
      this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        CaseSummary: this.CaseSummary.trim(),
        StatusFilter: this.StatusFilter,
      }
      this.$engine.toolbox.getTestCaseTB(
      //this.$engine.toolbox.getAccountTB(
        filterConditions
      ).then(resp => {
        this.RequestList = []
        this.AllRowName = []
        if (resp.data.TestCase) {
          let requests = []
          if(resp.data.TestCase.List){
            let result = []
            if(!Array.isArray(resp.data.TestCase.List))
              result.push(resp.data.TestCase.List)
            else {
              result = resp.data.TestCase.List
            }
            if (result.length > 0){
              result.forEach( test =>{
                let aux = {}
                aux.id = test["~Unknown_1"]
                if(aux.id !== "$NotFound") {
                  aux.case_summary = test["~Unknown_2"]
                  aux.description_case = test["~Unknown_3"]
                  aux.case_type = test["~Unknown_4"]
                  aux.case_type_detailed = test["~Unknown_5"]
                  aux.tested_field = test["~Unknown_6"]
                  aux.criticality = test["~Unknown_7"]
                  aux.status = test["~Unknown_8"]
                  let execution = test["~Unknown_9"]
                  execution = execution.replace("T", " ")
                  execution = this.date_format(execution)
                  aux.lastExec = execution
                  const foundElement = requests.find(item => item.id === aux.id);
                  if (foundElement) {
                    if (aux.id_dataset.length > 0)
                      foundElement.ids_dataset.push(aux.id_dataset)
                  } else {
                    let newTestCase = {
                      id: aux.id,
                      case_summary: aux.case_summary,
                      description_case: aux.description_case,
                      case_type: aux.case_type,
                      case_type_detailed: aux.case_type_detailed,
                      tested_field: aux.tested_field,
                      criticality: aux.criticality,
                      status: aux.status,
                      lastExec : aux.lastExec,
                      ids_dataset: [],
                      ids_valid: []
                    }
                    requests.push(newTestCase)
                  }
                }
              })
            }
          }
          if(resp.data.TestCase.DatasetCount){
            let result = []
            if(!Array.isArray(resp.data.TestCase.DatasetCount))
              result.push(resp.data.TestCase.DatasetCount)
            else {
              result = resp.data.TestCase.DatasetCount
            }
            if (result.length > 0) {
              result.forEach(test => {
                let cur = {}
                cur.idTestCase = test["~Unknown_1"]
                cur.idDataset = test["~Unknown_2"]
                const foundElement = requests.find(item => item.id === cur.idTestCase);
                if (foundElement) {
                  if (cur.idDataset.length > 0)
                    foundElement.ids_dataset.push(cur.idDataset)
                }
              })
            }
          }
          if(resp.data.TestCaseValid){
            let testCaseValid = []
            if(Array.isArray(resp.data.TestCaseValid))
              testCaseValid = resp.data.TestCaseValid
            else
              testCaseValid.push(resp.data.TestCaseValid)
            testCaseValid.forEach(valid_dataset => {
              let aux = {}
              aux.idTC = valid_dataset["~Unknown_1"]
              aux.idDS = valid_dataset["~Unknown_2"]
              aux.idStatus = valid_dataset["~Unknown_3"]
              aux.lastExec = valid_dataset["~Unknown_4"]
              const foundElement = requests.find(item => item.id === aux.idTC);
              if(foundElement) {
                foundElement.ids_valid.push(aux.idDS)
              }
            })
          }

          if(resp.data.AllTestCaseName){
            let result = []
            if(!Array.isArray(resp.data.AllTestCaseName))
              result.push(resp.data.AllTestCaseName)
            else {
              result = resp.data.AllTestCaseName
            }
            result.forEach(rowName => {
              this.AllRowName.push(rowName["~Unknown_2"])
            })
          }

          that.paginationObject.nbResultsTotal = resp.data.TestCaseCount
          that.paginationObject.nbResults = requests.length
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/requestTBDetails/' + id})
    },
    reOrderBy (column) {
      this.AccountTBList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.accountTB.getAccountTB(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
        that.paginationObject.nbResults = resp.data.tracks.length
        requests = resp.data.accounts
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.RequestList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeRequestTBDetails (items) {
      console.log("details")
      console.log(items)
      console.log("details")
      this.activateDetail(items.id)
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },

    trigOnImportCSV(){
      //console.log("start importCSV")
      this.$refs.fileInput.click();
    },
    onImportCSV(event) {
      //console.log("import csv")
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader()
        let validCSV = true
        reader.onload = (e) => {
          const csvContent = e.target.result
          validCSV = validCSV && this.isCSV(file) &&  this.isCSVContent(csvContent)
          if(validCSV)
            this.parseCSV(csvContent)
          else{
            this.okMessageBox(this.$t('toolbox.import_error_format'))
          }
        };
        reader.readAsText(file);
        this.$refs.fileInput.value = ""
      }
    },
    isCSV (file) {
      const validMimeTypes = ['text/csv', 'application/vnd.ms-excel']
      const extension = file.name.split('.').pop().toLowerCase()
      return validMimeTypes.includes(file.type) && extension === 'csv'
    },
    isCSVContent (content) {
      const lines = content.trim().split('\n')

      const delimiter = content.includes(';') ? ';' : ','
      const firstLineColumns = lines[0].split(delimiter).length

      return lines.every(line => line.split(delimiter).length === firstLineColumns)
    },
    parseCSV(csvContent) {
      const lines = csvContent.trim().split('\r\n')
      const delimiter = csvContent.includes(';') ? ';' : ','
      //const headers = lines.shift().split(delimiter);
      let that = this
      let request = {}
      //console.log("check_header")
      const headers = lines[0].split(delimiter);
      const unknown_header = []
      let foundID = false;
      let foundDESC = false;
      headers.forEach(header => {
        if(!this.validHeader(header))
          unknown_header.push(header)
        if(header === "ID_TEST_CASE")
          foundID = true;
        if(header === "DESCRIPTION")
          foundDESC = true;
      })
      if(unknown_header.length > 0) {
        this.okMessageBox(this.$t('toolbox.import_error_unknown_header'))
        return
      }
      if(!foundID || !foundDESC) {
        this.okMessageBox(this.$t('toolbox.import_error_obligatory_field_not_found'))
        return
      }
      request.delimiter = delimiter
      request.content = []
      lines.forEach(lineContent => {
        const content = lineContent.split(delimiter)
        if(content !== undefined && content.length > 0)
          request.content.push(lineContent)
      })

      if(request.content.length === 1) {
        this.okMessageBox(this.$t('toolbox.import_empty_csv'))
        return
      }

      that.$engine.toolbox.ImportTestCase(
          request
      ).then(resp => {
        if(resp.data.error)
          this.okMessageBox(this.$t('toolbox.import_content_error'))
        else
          this.onRefresh()
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    date_format(date){
      let cleanedDate = date.includes('+') ? date.split('+')[0] : date;
      cleanedDate = cleanedDate.includes('.') ? cleanedDate.split('.')[0] : cleanedDate;
      return cleanedDate
    },
    validHeader(header){
      switch (header){
        case 'ID_TEST_CASE' :
        case 'DESCRIPTION' :
        case 'IBAN' :
        case 'NAME' :
        case 'X_REQUEST_ID' :
        case 'X_RESPONSE_TIMESTAMP' :
        case 'CONTENT_TYPE' :
        case 'NAME_MATCH' :
        case 'ID_MATCH' :
        case 'MATCHED_NAME' :
        case 'ERROR_TYPE' :
        case 'ERROR_CODE' :
        case 'ERROR_STATUS' :
        case 'ERROR_DETAIL' :
        case 'ERROR_INSTANCE' :
        case 'SIREN' :
        case 'SIRET' :
        case 'TVAINTRACOMM' :
        case 'EUID' :
        case 'LEI' :
        case 'BIC' :
        case 'IDENTIFIER' :
        case 'SCHEME_NAME_CODE' :
        case 'SCHEME_NAME_PROPRIETARY' :
        case 'RESPONDING_BICFI' :
        case 'REQUESTING_BICFI' :
        case 'USTRD_INFO' :
        case 'IDENTIFICATION' :
        case 'HTTP_CODE' :
        case 'HTTP_MESSAGE' :
        case 'ERROR_TITLE' :
          return true
        default :
          return false
      }
    },
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

</style>
